import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { FileResponse } from 'sc-common'; import { ApiFileInfo } from 'sc-common/core/services/open-api/open-api-clients';

@Component({
    selector: 'et-paper-copyright-download',
    templateUrl: './paper-copyright-download.component.html',
    styleUrls: ['./paper-copyright-download.component.scss'],
    standalone: false
})
export class PaperCopyrightDownloadComponent {

    @Input()
    public fileInfo: ApiFileInfo;

    @Input()
    public download$: Observable<FileResponse>;
}
